import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  private loadingCount = signal<number>(0);
  private loadingMessages = signal<Map<string, string>>(new Map());
  
  // Public readonly signal for components to use
  readonly isLoading = signal<boolean>(false);
  readonly loadingMessage = signal<string>('Loading...');

  /**
   * Show loader with optional message
   */
  show(message?: string, requestId?: string): void {
    const id = requestId || `req_${Date.now()}_${Math.random()}`;
    
    if (message) {
      const messages = new Map(this.loadingMessages());
      messages.set(id, message);
      this.loadingMessages.set(messages);
      this.loadingMessage.set(message);
    }
    
    this.loadingCount.update(count => count + 1);
    this.isLoading.set(true);
  }

  /**
   * Hide loader
   */
  hide(requestId?: string): void {
    if (requestId) {
      const messages = new Map(this.loadingMessages());
      messages.delete(requestId);
      this.loadingMessages.set(messages);
      
      // Update message if there are other active requests
      if (messages.size > 0) {
        const lastMessage = Array.from(messages.values())[messages.size - 1];
        this.loadingMessage.set(lastMessage);
      } else {
        this.loadingMessage.set('Loading...');
      }
    }
    
    this.loadingCount.update(count => {
      const newCount = Math.max(0, count - 1);
      if (newCount === 0) {
        this.isLoading.set(false);
        this.loadingMessages.set(new Map());
        this.loadingMessage.set('Loading...');
      }
      return newCount;
    });
  }

  /**
   * Force hide all loaders (useful for error cases)
   */
  forceHide(): void {
    this.loadingCount.set(0);
    this.isLoading.set(false);
    this.loadingMessages.set(new Map());
    this.loadingMessage.set('Loading...');
  }
}

